<template>
	<div class="icon-wrap">
		<div class="share-icon" ref="showPanel" @click="click">
			<img width="100%" height="100%" src="../assets/share.png" />
		</div>
		<div class="cover" :style="{ width: width, transition: transition }">
			<div class="icon-list">
				<a
					class="icon-item"
					v-for="(item, index) in shareList"
					:key="index"
					:href="item.link"
					target="_blank"
					@mouseenter="item.type==undefined?'':showQrcode=true"
        			@mouseout="item.type==undefined?'':showQrcode=false"
				>
					<img width="100%" height="100%" :src="item.icon" />
				</a>
			</div>
		</div>
		<div class="wechat-qrcode" v-show="showQrcode">
			<h4>微信扫一扫：分享</h4>
			<div class="qrcode">
				<img
					src="data:image/png;base64,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"
				/>
			</div>
			<div class="help">
				<p>微信里点“发现”，扫一下</p>
				<p>二维码便可将本文分享至朋友圈。</p>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			show: false,
			showQrcode:false,
			iconList: [
				{
					src: '',
				},
			],
			transition: 'width 0.2s',
			width: '0',
			shareList: [
				{
					icon: require('../assets/weibo.png'),
					link:
						'https://service.weibo.com/share/share.php?url=http%3A%2F%2Fwww.futureprize.org%2Fcn%2Fnav%2Fdetail%2F932.html&title=2020%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96%E4%B8%BE%E8%A1%8C%E4%BA%91%E7%AB%AF%E9%A2%81%E5%A5%96%E5%85%B8%E7%A4%BC%20%7C%20%E7%A7%91%E5%AD%A6%E4%B9%8B%E5%85%89%20%E6%B8%A9%E6%9A%96%E4%B8%96%E7%95%8C%E2%80%8B%20-%20%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&pic=http%3A%2F%2Fwww.futureprize.org%2Fresource%2Fdata%2Fuploads%2F30%2F1a98888a670638c562deabfd705a4e3f.png&appkey=#_loginLayer_1620280296765',
				},
				{
					icon: require('../assets/icon-qzone.png'),
					link:
						'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=http%3A%2F%2Fwww.futureprize.org%2Fcn%2Fnav%2Fdetail%2F932.html&title=2020%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96%E4%B8%BE%E8%A1%8C%E4%BA%91%E7%AB%AF%E9%A2%81%E5%A5%96%E5%85%B8%E7%A4%BC%20%7C%20%E7%A7%91%E5%AD%A6%E4%B9%8B%E5%85%89%20%E6%B8%A9%E6%9A%96%E4%B8%96%E7%95%8C%E2%80%8B%20-%20%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&desc=%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&summary=%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&site=2020%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96%E4%B8%BE%E8%A1%8C%E4%BA%91%E7%AB%AF%E9%A2%81%E5%A5%96%E5%85%B8%E7%A4%BC%20%7C%20%E7%A7%91%E5%AD%A6%E4%B9%8B%E5%85%89%20%E6%B8%A9%E6%9A%96%E4%B8%96%E7%95%8C%E2%80%8B%20-%20%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96',
				},
				{
					icon: require('../assets/icon-qq.png'),
					link:
						'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=http%3A%2F%2Fwww.futureprize.org%2Fcn%2Fnav%2Fdetail%2F933.html&title=2020%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96%E9%A2%81%E5%8F%91%E5%85%B8%E7%A4%BC%20-%20%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&desc=%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&summary=%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&site=2020%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96%E9%A2%81%E5%8F%91%E5%85%B8%E7%A4%BC%20-%20%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96',
				},
				{
					icon: require('../assets/wechat-qrcode.png'),
					link: '#',
					type:'wechatQrcode'
				},
				{
					icon: require('../assets/icon-douban.png'),
					link:
						'http://shuo.douban.com/!service/share?href=http%3A%2F%2Fwww.futureprize.org%2Fcn%2Fnav%2Fdetail%2F932.html&name=2020%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96%E4%B8%BE%E8%A1%8C%E4%BA%91%E7%AB%AF%E9%A2%81%E5%A5%96%E5%85%B8%E7%A4%BC%20%7C%20%E7%A7%91%E5%AD%A6%E4%B9%8B%E5%85%89%20%E6%B8%A9%E6%9A%96%E4%B8%96%E7%95%8C%E2%80%8B%20-%20%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&text=%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&image=http%3A%2F%2Fwww.futureprize.org%2Fresource%2Fdata%2Fuploads%2F30%2F1a98888a670638c562deabfd705a4e3f.png&starid=0&aid=0&style=11',
				},
				{
					icon: require('../assets/icon-linkedin.png'),
					link:
						'http://www.linkedin.com/shareArticle?mini=true&ro=true&title=2020%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96%E4%B8%BE%E8%A1%8C%E4%BA%91%E7%AB%AF%E9%A2%81%E5%A5%96%E5%85%B8%E7%A4%BC%20%7C%20%E7%A7%91%E5%AD%A6%E4%B9%8B%E5%85%89%20%E6%B8%A9%E6%9A%96%E4%B8%96%E7%95%8C%E2%80%8B%20-%20%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&url=http%3A%2F%2Fwww.futureprize.org%2Fcn%2Fnav%2Fdetail%2F932.html&summary=%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&source=2020%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96%E4%B8%BE%E8%A1%8C%E4%BA%91%E7%AB%AF%E9%A2%81%E5%A5%96%E5%85%B8%E7%A4%BC%20%7C%20%E7%A7%91%E5%AD%A6%E4%B9%8B%E5%85%89%20%E6%B8%A9%E6%9A%96%E4%B8%96%E7%95%8C%E2%80%8B%20-%20%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&armin=armin',
				},

				{
					icon: require('../assets/icon-facebook.png'),
					link:
						'https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fwww.futureprize.org%2Fcn%2Fnav%2Fdetail%2F932.html&title=2020%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96%E4%B8%BE%E8%A1%8C%E4%BA%91%E7%AB%AF%E9%A2%81%E5%A5%96%E5%85%B8%E7%A4%BC%20%7C%20%E7%A7%91%E5%AD%A6%E4%B9%8B%E5%85%89%20%E6%B8%A9%E6%9A%96%E4%B8%96%E7%95%8C%E2%80%8B%20-%20%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&description=%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&caption={{SUBHEAD}}&link=http%3A%2F%2Fwww.futureprize.org%2Fcn%2Fnav%2Fdetail%2F932.html&picture=http%3A%2F%2Fwww.futureprize.org%2Fresource%2Fdata%2Fuploads%2F30%2F1a98888a670638c562deabfd705a4e3f.png',
				},
				{
					icon: require('../assets/icon-twitter.png'),
					link:
						'https://twitter.com/intent/tweet?text=2020%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96%E4%B8%BE%E8%A1%8C%E4%BA%91%E7%AB%AF%E9%A2%81%E5%A5%96%E5%85%B8%E7%A4%BC%20%7C%20%E7%A7%91%E5%AD%A6%E4%B9%8B%E5%85%89%20%E6%B8%A9%E6%9A%96%E4%B8%96%E7%95%8C%E2%80%8B%20-%20%E6%9C%AA%E6%9D%A5%E7%A7%91%E5%AD%A6%E5%A4%A7%E5%A5%96&url=http%3A%2F%2Fwww.futureprize.org%2Fcn%2Fnav%2Fdetail%2F932.html&via=http%3A%2F%2Fwww.futureprize.org',
				},
				{
					icon: require('../assets/icon-google.png'),
					link:
						'https://plus.google.com/share?url=http%3A%2F%2Fwww.futureprize.org%2Fcn%2Fnav%2Fdetail%2F932.html',
				},
			],
		}
	},
	mounted() {
		document.addEventListener('click', (e) => {
			if (this.$refs.showPanel) {
				let isSelf = this.$refs.showPanel.contains(e.target)
				if (!isSelf) {
					this.hide()
				}
			}
		})
	},
	methods: {
		hide() {
			this.transition = 'width .8s'
			this.width = '0'
		},
		click() {
			this.transition = 'width .2s'
			this.width = '0'
			setTimeout(() => {
				this.width = '100vw'
			}, 200)
		},
	},
}
</script>
<style lang="scss" scoped>
.icon-wrap {
	.share-icon {
		width: 2rem;
		height: 1.6rem;
		cursor: pointer;
	}
	.cover {
		overflow: hidden;
		.icon-list {
			padding: 0.5rem 0 1rem 3rem;
			display: flex;
			flex-wrap: nowrap;
			width: 100vw;
			.icon-item {
				margin: 0.28rem;
				// border: 0.1rem solid #666;
				border-radius: 50%;
				width: 3rem;
				height: 3rem;
				padding: 0.2rem;
				cursor: pointer;
			}
		}
	}
}
.wechat-qrcode {
	position: relative;
	top: -18.5rem;
	left: 8rem;
	border: 1px solid #eee;
	z-index: 9;
	width: 200px;
	height: 192px;
	color: #666;
	font-size: 12px;
	text-align: center;
	background-color: #fff;
	box-shadow: 0 2px 10px #aaa;
	transition: all 200ms;
	-webkit-tansition: all 350ms;
	-moz-transition: all 350ms;
}
.wechat-qrcode h4 {
	font-weight: normal;
	height: 26px;
	line-height: 26px;
	font-size: 12px;
	background-color: #f3f3f3;
	margin: 0;
	padding: 0;
	color: #777;
}
.wechat-qrcode .qrcode {
	width: 105px;
	margin: 10px auto;
}
.wechat-qrcode .help p {
	font-weight: normal;
	line-height: 16px;
	padding: 0;
	margin: 0;
}
</style>
